export default __webpack_public_path__ + "static/media/like-outline.c2c862bd.svg";